import React, { useState } from "react";
import ReactModal from "react-modal";
import MinMaxChart from "./MinMaxChart";
import Datetime from "react-datetime";

const CurrentValueModal = ({ isOpen, onClose, deviceid, dataType }) => {

  const [fromDate, setFromDate] = useState(
    new Date(new Date().setFullYear(new Date().getFullYear() - 1))
  );
  const [toDate, setToDate] = useState(new Date());

  return (
    <ReactModal isOpen={isOpen} contentLabel="Anturin arvo" ariaHideApp={false}>
      <div className="modal-header">
        <h2>Valitse aikaväli</h2>
        <Datetime
          closeOnSelect={true}
          className="dateinput"
          value={fromDate}
          onChange={(date) => {
            if (date && date.toDate) {
              setFromDate(date.toDate());
            }
          }}

        />
        <div>&mdash;</div>
        <Datetime
          closeOnSelect={true}
          className="dateinput"
          value={toDate}
          onChange={(date) => setToDate(date.toDate())}
        />

        <button onClick={onClose}>Sulje</button>
      </div>
      <div className="modal-body">
        <MinMaxChart
          deviceId={deviceid}
          fromDate={fromDate}
          toDate={toDate}
          dataType={dataType}
        />
      </div>
    </ReactModal>
  );
};

export default CurrentValueModal;
